<template>
  <div class="position-relative">
    <v-select class="productSelect" v-model="product" ref="select" :options="options" label="text"
      :disabled="options.length < 1 || disabled" :onChange="onChange" placeholder="Product Search">
    </v-select>
    <div v-show="options.length < 1" class="db-help product">
      <b-dropdown variant="link" toggle-class="text-decoration-none" dropup no-caret>
        <template slot="button-content">
          <b-img src="/images/icons/information.png" />
        </template>
        <b-dropdown-text class="mb-0 py-1 px-2" style="width: 304px">
          Learn more about this Supreme feature by clicking <b-link to="/enterprise-features?product=1">here!</b-link>
        </b-dropdown-text>
      </b-dropdown>
    </div>
    <b-btn class="product-multiple-btn btn-blue" @click="onShowModal" v-show="product">
      +/- Products
    </b-btn>

    <b-modal ref="modal" size="xl" centered lazy no-close-on-esc no-close-on-backdrop :hide-header="true"
      class="product-modal">
      <button @click="onHideModal(false)" type="button" aria-label="Close" class="close"
        style="font-size: 1.75rem">×</button>

      <b-form-row class="product-table mt-3">
        <b-col sm="8">
          <h6 class="mb-4">Product Catalogue</h6>
          <div class="table-wrapper mb-4">
            <table class="table table-striped table-bordered text-center">
              <thead>
                <tr>
                  <th style="width: 300px;">
                    <b-btn size="sm" variant="secondary" class="sort-btn default" @click="() => {
                      sortField('product_name', product_sort);
                      product_sort = product_sort == 'desc' ? 'asc' : 'desc'
                    }">
                      PRODUCT
                      <i :class="['fa', product_sort ? `fa-sort-${product_sort}` : 'fa-sort']" aria-hidden="true"></i>
                    </b-btn>
                  </th>
                  <th>
                    <b-btn size="sm" variant="secondary" class="sort-btn default" @click="() => {
                      sortField('sku', sku_sort);
                      sku_sort = sku_sort == 'desc' ? 'asc' : 'desc'
                    }">
                      SKU
                      <i :class="['fa', sku_sort ? `fa-sort-${sku_sort}` : 'fa-sort']" aria-hidden="true"></i>
                    </b-btn>
                  </th>
                  <th style="width: 125px;">
                    <b-btn size="sm" variant="secondary" class="sort-btn default">
                      QUANTITY
                    </b-btn>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!items.length">
                  <td colspan="3" class="text-center">
                    No Products found
                  </td>
                </tr>
                <tr v-else v-for="item in items" :key="item.id">
                  <td>{{ item.product_name }}</td>
                  <td>{{ item.sku }}</td>
                  <td>
                    <b-btn size="sm" class="btn-blue mr-2 circle default"
                      @click="updateQuantity(item.id, false)">-</b-btn>
                    <span class="quantity">{{ item.quantity || '0' }}</span>
                    <b-btn size="sm" class="btn-blue ml-2 circle default" @click="updateQuantity(item.id)">+</b-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="package">
            <b-form-row>
              <b-col>
                <b-form-group>
                  <!-- service class options -->
                  <b-form-select size="sm" :options="serviceOptions" v-model="selectedService"
                    :class="[{ 'is-invalid': !selectedService }]" name="service" @change="onServiceClassChange">
                    <template slot="first">
                      <option :value="''" disabled>Select Service Class</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group>
                  <!-- package options -->
                  <b-form-select size="sm" :options="packageOptions" :class="[{ 'is-invalid': !selectedPackage }]"
                    :disabled="!selectedService" v-model="selectedPackage" name="package">
                    <template slot="first">
                      <option :value="''" disabled>Select Package Type</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group>
                  <!-- MY PACKAGING -->
                  <b-form-select size="sm" :options="dimensionsPresetOptions" v-model="tmpMyPkg"
                    :disabled="!(dimensionsPresetOptions.length > 1)" name="customsContentType"
                    @change="onPackagingSelected"></b-form-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <!-- WEIGHT -->
              <b-col sm="1">
                <label class="p-1">
                  <b-img src="/images/icons/wgt-sm.png" width="25" v-b-tooltip.hover title="Weight" />
                </label>
              </b-col>
              <b-col>
                <b-form-group>
                  <b-form-input size="sm" type="number" placeholder="LB" :class="[{ 'is-invalid': noWeight && !noLB }]"
                    v-model="weight.lb" :disabled="noLB" @change="setWeight"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <b-form-input size="sm" type="number" placeholder="OZ" :class="[{ 'is-invalid': noWeight }]"
                    v-model="weight.oz" @change="setWeight" />
                </b-form-group>
              </b-col>
              <b-col sm="1">
                <label class="pull-right p-1">
                  <b-img src="/images/icons/dim-sm.png" width="25" v-b-tooltip.hover title="Dimensions" />
                </label>
              </b-col>
              <!-- DIMENSION -->
              <b-col sm="2">
                <b-form-group>
                  <b-form-input size="sm" :disabled="isDimAllowed" type="number"
                    :class="[{ 'is-invalid': !checkDimensions }]" placeholder="L" v-model="dimensions.l" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <b-form-input size="sm" :disabled="isDimAllowed" type="number"
                    :class="[{ 'is-invalid': !checkDimensions }]" placeholder="W" v-model="dimensions.w" />
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                  <b-form-input size="sm" :disabled="isDimAllowed" type="number"
                    :class="[{ 'is-invalid': !checkDimensions }]" placeholder="H" v-model="dimensions.h" />
                </b-form-group>
              </b-col>
            </b-form-row>
          </div>
        </b-col>

        <b-col sm="4">
          <b-row class="h-100">
            <b-col sm="12">
              <b-input class="search" v-model="searchTerm" placeholder="Search" size="sm" @input="onSearchInput" />
              <b-row class="justify-content-center"><span class="summary">SUMMARY</span></b-row>
              <b-row>
                <b-col sm="6" class="font-weight-bolder">Product</b-col>
                <b-col sm="2" class="text-right font-weight-bolder">Qty</b-col>
                <b-col class="text-right font-weight-bolder">Declared Value</b-col>
              </b-row>
              <b-row v-for="s in summary" :key="s.id">
                <b-col sm="6">{{ getProductName(s) }}</b-col>
                <b-col sm="2" class="text-right">x {{ s.quantity }}</b-col>
                <b-col class="text-right">{{ getTotal(s) }}</b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="align-self-end mb-3">
              <b-row v-show="totalQuantity">
                <b-col sm="6">Total Products:</b-col>
                <b-col sm="2" class="text-right">x {{ totalQuantity }}</b-col>
                <b-col class="text-right">${{ totalDeclaredValue }}</b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>

      <div slot="modal-footer" class="w-100 text-right">
        <div class="float-left">
          <b-btn class="btn-light-blue-outline" size="sm" @click="onClearItems(false)">Clear All Fields</b-btn>
        </div>
        <div class="float-right">
          <b-btn class="btn-blue" size="sm" :disabled="!summary.length" @click="onHideModal(true)">Save and
            Close</b-btn>
          <!-- <b-btn
            size="sm"
            style="background-color: #858888; border: 1px solid #858888;"
            @click="onHideModal(false)"
          >Close</b-btn> -->
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.product-modal {
  button {
    font-size: 0.75rem;
  }
}

.package {
  .form-group {
    margin-bottom: 0.5rem;
  }
}

.sort-btn {
  position: relative;
  background: #29286c !important;
  padding: 0.45rem 1rem !important;
  display: block !important;
  width: 100%;
  font-size: 0.75rem !important;

  i {
    position: absolute;
    right: 7px;
    top: 30%;
  }
}

button.circle {
  border-radius: 50%;
  padding: 0 0.4rem;
  font-size: .75rem;
}

.product-table {
  font-size: 0.75rem;

  .search {
    margin-bottom: 0.75rem;
  }

  input,
  select {
    font-size: 0.75rem !important;
  }

  span {
    &.quantity {
      display: inline-block;
      width: 25px;
    }

    &.summary {
      background: #29286c;
      color: #fff;
      display: block;
      width: 97.5%;
      text-align: center;
      margin-bottom: .75rem;
      padding: 0.5rem 1rem !important;
      border: 1px solid #dee2e6;
    }
  }

  .table-wrapper {
    height: 240px;
    overflow-y: auto;
  }

  th {
    padding: 0 !important;
  }

  td {
    padding: 0.5rem 0rem !important;
  }
}

.product-multiple-btn {
  position: absolute;
  right: 32px;
  top: 6px;

  padding: 0.1rem 0.25rem !important;
  font-size: 0.75rem !important;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['disabled', 'country', 'product_data'],
  data() {
    return {
      product_sort: '',
      sku_sort: '',
      tmpMyPkg: '0x0x0',
      selectedService: '',
      selectedPackage: '',
      noLB: false,
      weight: { lb: null, oz: null },
      dimensions: { l: null, w: null, h: null },
      searchTerm: null,
      product: null,
      attributes: {
        'ref': 'openIndicator',
        'role': 'presentation',
        'class': 'vs__open-indicator',
      },
      hasOrder: false,
      revert: false,
      items: [],
      cloned_items: [],
      saved_items: [],
      tmp_items: [],
    };
  },
  computed: {
    ...mapGetters({
      products: 'products',
      user: "getUser",
      getCarrierRules: "getCarrierRules",
      shipping_services: "getShippingServices",
      getShippingService: "getShippingService",
    }),
    options() {
      if (!this.products) {
        return [];
      }
      const products = { ...this.products };
      const options = _.map(products, p => {
        return {
          value: p.id,
          text: `${p.product_name}${p.sku ? ` [${p.sku}]` : ''}`
        };
      });
      return options;
    },
    carrierRules: function () {
      return this.getCarrierRules(this.country || 'US');
    },
    serviceRules() {
      return this.carrierRules[this.selectedService] || [];
    },
    dimensionsPresetOptions() {
      let options = this.user.dimensions
        ? this.user.dimensions.map(dimension => {
          return {
            value: `${dimension.length}x${dimension.width}x${dimension.height}`,
            text: dimension.name
          };
        })
        : [];

      options = _.concat({
        value: '0x0x0',
        text: 'My Packaging',
      }, options);
      return options;
    },
    serviceOptions() {
      try {
        let options = Object.keys(this.carrierRules).map(serviceId => {
          return _.find(this.shipping_services, s => {
            return s && s.code === serviceId;
          });
        });

        options = _.orderBy(_.filter(options), "order");

        options = options.map(option => {
          let packageOptions = this.getPackageOptions(option.code);

          // Make sure at least 1 option exists
          if (!packageOptions.length) {
            return null;
          }

          return {
            value: option.code,
            text: option.name
          };
        });

        return _.filter(options);
      } catch (e) {
        // console.error(e);
        return [];
      }
    },
    packageOptions() {
      if (
        _.isEmpty(this.selectedService) ||
        !this.serviceRules["parcelTypeRules"]
      ) {
        this.selectedPackage = '';
        return [];
      }

      return this.getPackageOptions(this.selectedService);
    },
    noWeight() {
      const { oz, lb } = this.weight;
      const isNull = [NaN, 0];
      if (isNull.includes(parseInt(oz)) && isNull.includes(parseInt(lb))) return true;
      return false;
    },
    checkDimensions() {
      const { height, width, length } = this.dimensions;
      const hasAll = height && width && length;
      if (this.selectedPackage === "SOFTPACK") {
        if (!hasAll) return false;
        return true;
      } else {
        const dim = [parseInt(height), parseInt(width), parseInt(length)];
        const hasNull = dim.some(d => isNaN(d) || d < 1)
        const hasVal = dim.some(d => d > 0)
        if (hasNull && hasVal) return false
        return true;
      }
    },
    isDimAllowed() {
      if (this.selectedPackage) {
        if (["SOFTPACK", "PKG"].includes(this.selectedPackage)) return false;
        this.dimensions = { l: null, w: null, h: null };
        this.dw_set = true;
        return true;
      }
      return false;
    },
    summary() {
      return this.saved_items.filter(i => i.quantity)
    },
    totalQuantity() {
      return this.summary.reduce((a, b) => a + b.quantity, 0);
    },
    totalDeclaredValue() {
      return parseFloat(this.summary.reduce((a, b) => a + b.quantity * parseFloat(b.declared_value), 0)).toFixed(2);
    }
  },
  created() {
    this.refreshProducts();
  },
  async beforeMount() {
    if (this.product_data) {
      this.hasOrder = true;
      if (!this.items.length) {
        const { data } = await axios.get('/products/all');
        this.items = this.cloned_items = _.map(data, p => p);
      }
      let items = this.product_data.selectedProduct;
      if (items) {
        items.forEach(item => {
          const pIndex = this.items.findIndex(i => i.id === item.id)
          this.$set(this.items, pIndex, item)
          this.save_product(item.id, item);
        })

        if (items.length > 1) {
          const products = items.reduce((a, b) => a + parseInt(b.quantity), 0);
          this.product = { text: `${products} Products`, value: null };
        } else {
          let name = items[0].product_name;
          if (items[0].quantity > 1) {
            name = `${items[0].quantity} Products`;
          } else if (items[0].sku) {
            name = `${items[0].product_name} [${items[0].sku}]`;
          }
          this.product = { text: name, value: null };
        }
      }
    }
  },
  methods: {
    ...mapActions(['refreshProducts']),
    onChange(val) {
      if (val) {
        this.$emit('input', val.value);
        this.$emit('change', val.value);
      } else {
        this.onClearItems();
        this.$emit('clear');
      }
    },
    async onServiceClassChange(val) {
      this.selectedService = val;
      this.selectedPackage = 'PKG';
      switch (val) {
        case "FCPIS":
          if (!this.noWeight) {
            const total_weight = ((this.weight.lb || 0) * 16) + (this.weight.oz || 0);
            if (total_weight > 64) {
              this.error_msg = "Maximum weight limit for First-Class Package International is 4lbs.";
              this.weight = Object.assign({}, { lb: 0, oz: 0 });
            }
          }
          break;
        case "FCM":
          this.noLB = true;
          this.weight.lb = 0;
          break;
        default:
          this.noLB = false;
      }
    },
    onPackagingSelected(val) {
      if (!val) return;
      const [l, w, h] = val.split('x');
      this.dimensions = { l: parseInt(l), w: parseInt(w), h: parseInt(h) };
    },
    setWeight() {
      if ([0, NaN].includes(parseInt(this.weight.oz)) && [0, NaN].includes(parseInt(this.weight.lb))) {
        return;
      } else if ([0, NaN].includes(parseInt(this.weight.oz)) && ![0, NaN].includes(parseInt(this.weight.lb))) {
        this.weight.oz = 0;
      }
      if (this.weight.oz % 16) {
        if (!this.noLB) {
          this.weight.lb =
            Number(~~(this.weight.oz / 16)) + Number(this.weight.lb);
          this.weight.oz = Number(this.weight.oz % 16);
        } else {
          this.weight.lb = 0;
          this.weight.oz = Number(this.weight.oz % 16);
        }
      }
      if (this.selectedService === "FCPIS") {
        const total_weight = (this.weight.lb * 16) + this.weight.oz;
        if (total_weight > 64) {
          this.weight = { lb: 0, oz: 0 };
          return;
        }
      }
    },
    getPackageOptions(serviceId) {
      let rules = this.$store.getters.getServicePackageRules(
        serviceId,
        this.country,
        true // filter inactive mail classes
      );

      const flatRates = {
        EM: {
          FRE: "$24.90",
          LGLFRENV: "$25.15",
          PFRENV: "$25.35"
        },
        PM: {
          FRE: "$7.60", // Flat Rate Envelope
          SFRB: "$8.10", // Small Flat Rate Box
          LFRB: "$18.95", // Large Flat Rate Box
          LGLFRENV: "$7.90", // Legal Flat Rate Envelope
          FRB: "$14.00", // Medium Flat Rate Box
          MLFRB: "$18.35", // APO/FPO/DPO
          PFRENV: "$8.30" // Padded Flat Rate Envelope
        }
      }
      let options = serviceId
        ? rules.map(rule => {
          let name = rule.brandedName;
          if (serviceId in flatRates && rule.parcelType in flatRates[serviceId]) {
            name += " - " + flatRates[serviceId][rule.parcelType];
          }
          return {
            value: rule.parcelType,
            text: name
          };
        })
        : [];

      return options
      // return _.orderBy(options, "text");
    },
    onClearItems(remove = true) {
      this.searchTerm = null;
      this.product_sort = '';
      this.sku_sort = '';
      this.saved_items = [];
      this.items = this.cloned_items = this.cloned_items.map(item => {
        item.quantity = 0;
        return { ...item }
      })
      this.selectedService = '';
      this.selectedPackage = '';
      this.tmpMyPkg = '0x0x0';
      this.weight = { lb: null, oz: null };
      this.dimensions = { l: null, w: null, h: null };
      if (remove) this.product = null;
    },
    onShowModal() {
      this.$refs.modal.show();
      if (!this.items.length) {
        const products = { ...this.products };
        this.items = this.cloned_items = _.map(products, p => p);
      }
      if (this.product_data) {
        if (this.product_data.selectedProduct && this.product_data.selectedProduct.length == undefined) {
          this.onClearItems(false);
          const id = this.product_data.selectedProduct.id
          const pIndex = this.items.findIndex(i => i.id === id)
          let product = this.items[pIndex]
          product.quantity = 1
          this.$set(this.items, pIndex, product)
          this.save_product(id, product);
        } else if (this.revert) {
          this.items = this.cloned_items = this.tmp_items
        } else if (this.product_data.selectedProduct.length && !this.hasOrder) {
          this.items = this.cloned_items = this.product_data.selectedProduct;
        }

        this.selectedService = this.product_data.selectedService
        this.selectedPackage = this.product_data.selectedPackage
        this.tmpMyPkg = this.product_data.tmpMyPkg
        this.weight = this.product_data.weight
        this.dimensions = this.product_data.dimensions

        if (this.selectedService == 'FCM') {
          this.noLB = true;
        }
      }
      this.tmp_items = _.cloneDeep(this.items)
    },
    onHideModal(save = false) {
      if (save) {
        this.revert = false;
        if (this.summary.length > 1) {
          this.product = { text: `${this.totalQuantity} Products`, value: null };
        } else {
          let name = this.summary[0].product_name;
          if (this.summary[0].quantity > 1) {
            name = `${this.summary[0].quantity} Products`;
          } else if (this.summary[0].sku) {
            name = `${this.summary[0].product_name} [${this.summary[0].sku}]`;
          }
          this.product = { text: name, value: null };
        }
        this.$emit('save', {
          selectedProduct: this.summary,
          selectedService: this.selectedService,
          selectedPackage: this.selectedPackage,
          tmpMyPkg: this.tmpMyPkg,
          weight: this.weight,
          dimensions: this.dimensions,
          declaredValue: this.totalDeclaredValue
        });
      } else {
        this.revert = true;
      }
      this.searchTerm = null;
      this.$refs.modal.hide();
    },
    onSearchInput(val) {
      this.product_sort = '';
      this.sku_sort = '';
      if (val) {
        val = val.toLowerCase();
        this.items = this.cloned_items.map(item => {
          const product_name = item.product_name ? item.product_name.toLowerCase() : '';
          const sku = item.sku ? item.sku.toLowerCase() : '';
          if (product_name.indexOf(val) > -1 || sku.indexOf(val) > -1) {
            return item;
          }
        }).filter(i => i !== undefined);
      } else {
        this.items = this.cloned_items;
      }
    },
    sortField(field, type = 'desc') {
      if (field == 'sku') {
        this.product_sort = '';
      } else {
        this.sku_sort = '';
      }
      this.items = _.orderBy(this.items, field, type)
    },
    updateQuantity(id, add = true) {
      const pIndex = this.items.findIndex(i => i.id === id)
      let product = this.items[pIndex]
      if (!product.quantity) {
        product.quantity = 0
      }

      if (add) {
        product.quantity++
      } else {
        if (!product.quantity == 0) {
          product.quantity--
        }
      }
      this.$set(this.items, pIndex, product)
      // save to separated array for calculation
      this.save_product(id, product);

      // set weight
      this.noLB = false;
      const total_weight = this.summary.reduce((a, b) => a + b.quantity * parseFloat(b.weight), 0);
      this.weight = this.getWeight(total_weight);
      this.setWeight();

      // set dimensions
      if (this.totalQuantity > 1 || this.totalQuantity < 1) {
        this.dimensions = { l: null, w: null, h: null };
      } else {
        const p = this.products[this.summary[0].id];
        this.dimensions = {
          l: parseFloat(p.package_length),
          w: parseFloat(p.package_width),
          h: parseFloat(p.package_height),
        };
      }

      // set service and package
      if (this.country === 'US') {
        if (this.weight.lb && this.selectedService === 'FCM') {
          this.selectedService = 'PM';
        }
      }
      // else {
      //   this.onServiceClassChange('FCPIS')
      // }
      if (!this.selectedPackage) {
        this.selectedPackage = 'PKG';
      }
    },
    save_product(id, product) {
      const pIndex = this.saved_items.findIndex(k => k.id === id)
      if (pIndex > -1) {
        this.$set(this.saved_items, pIndex, product)
      } else {
        this.saved_items.push(product);
      }
    },
    getWeight(weight) {
      const lb = Math.floor(weight / 16);
      const oz = Math.round(weight % 16);
      return {
        lb: lb + (oz > 15 ? 1 : 0),
        oz: (oz > 15) ? 0 : oz
      };
    },
    getProductName(p) {
      return (p.sku) ? `${p.product_name} [${p.sku}]` : p.product_name
    },
    getTotal(p) {
      if (parseFloat(p.declared_value) !== 0) {
        return `$${parseFloat(parseFloat(p.declared_value) * p.quantity).toFixed(2)}`
      }
      return 'N/A'
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Form/ProductSelect.vue